import React, { useState, useEffect } from 'react';
import Menu from './Menu';
import WeatherPanel from './weather/WeatherPanel';
import AuthTokenPanel from './AuthTokenPanel';
import { loadAuthTokenFromCookie, authToken } from './authToken';
import DiabetesPanel from './health/diabetes/DiabetesPanel';
import HealthDataManager from './health/HealthDataManager';
import GrafanaPanel from './display/GrafanaPanel';
import GestasPanel from './display/GestasPanel';
import AngelicarePanel from './display/AngelicarePanel';
import NoteListsPanel from './tasking/notes/NoteListsPanel';
import TaskListPanel from './tasking/tasks/TaskListPanel';
import CyclicTasksPanel from './tasking/tasks/CyclicTasksPanel';
import MonthlyTasksPanel from './tasking/tasks/MonthlyTasksPanel';
import MonthlyTaskAdderPanel from './tasking/tasks/MonthlyTaskAdderPanel';
import EventListPanel from './tasking/events/EventListPanel';
import CCPanel from './fin/CCPanel';
import BalanceAccountPanel from './fin/BalanceAccountPanel';
import BybitPanel from './fin/BybitPanel';
import CashflowExpensePanel from './fin/CashflowExpensePanel';
import CashflowTrackerPanel from './fin/CashflowTrackerPanel';
import DriveInfoListPanel from './doc/DriveInfoListPanel';
import ImageDisplayPanel from './display/ImageDisplayPanel';
import FoodIntakePanel from './health/food/FoodIntakePanel';
import MacroCalcPanel from './health/food/MacroCalcPanel';
import FoodIntakeTemplateListPanel from './health/food/FoodIntakeTemplateListPanel';
import BaseAddPanel from './health/diabetes/BaseAddPanel';
import DailyEventsAddPanel from './health/other/DailyEventsAddPanel';
import SugarAddPanel from './health/diabetes/SugarAddPanel';
import InsulinAddPanel from './health/diabetes/InsulinAddPanel';
import ModalShell from './components/ModalShell';
import ShortcutsPanel from './ShortcutsPanel';
import './App.css';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [loggedIn, setLoggedIn] = useState(!!authToken);
  const [showWeather, setShowWeather] = useState(false);
  const [showDiabetes, setShowDiabetes] = useState(false);
  const [showHealthDataManager, setShowHealthDataManager] = useState(false);
  const [showFoodIntake, setShowFoodIntake] = useState(false);
  const [showFoodTemplates, setShowFoodTemplates] = useState(false);
  const [showMacroCalc, setShowMacroCalc] = useState(false);
  const [showBaseAdd, setShowBaseAdd] = useState(false);
  const [showDailyEventsAdd, setShowDailyEventsAdd] = useState(false);
  const [showSugarAdd, setShowSugarAdd] = useState(false);
  const [showInsulinAdd, setShowInsulinAdd] = useState(false);
  const [showGrafana, setShowGrafana] = useState(false);
  const [showGestas, setShowGestas] = useState(false);
  const [showAngelicare, setShowAngelicare] = useState(false);
  const [showNoteLists, setShowNoteLists] = useState(false);
  const [showTaskLists, setShowTaskLists] = useState(false);
  const [showCyclicTasks, setShowCyclicTasks] = useState(false);
  const [showMonthlyTasks, setShowMonthlyTasks] = useState(false);
  const [showMonthlyTaskAdder, setShowMonthlyTaskAdder] = useState(false);
  const [showEventLists, setShowEventLists] = useState(false);  
  const [showCC, setShowCC] = useState(false);
  const [showBalanceAccounts, setShowBalanceAccounts] = useState(false);
  const [showBybit, setShowBybit] = useState(false);
  const [showCashflowExpenses, setShowCashflowExpenses] = useState(false);
  const [showCashflowTracker, setShowCashflowTracker] = useState(false);
  const [showDriveInfo, setShowDriveInfo] = useState(false);
  const [displayImage, setDisplayImage] = useState(null);

  // On mount, load token from cookie
  useEffect(() => {
    loadAuthTokenFromCookie();
    setLoggedIn(!!authToken);
  }, []);

  return (
    <div className="AppRoot" style={{ height: '100vh', overflow: 'hidden' }}>
      <div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          padding: '16px'
        }}>
          <button
            onClick={() => setMenuOpen(true)}
            style={{
              fontSize: '2rem',
              background: 'none',
              border: 'none',
              cursor: 'pointer'
            }}
            aria-label="Open menu"
          >&#9776;</button>
          <span style={{ marginLeft: 16, fontSize: '1.4rem' }}>
            {loggedIn ? 'Witaj, Karol Wojtyla!' : 'Kozle sprawy'}
          </span>
        </div>
        <Menu
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          onShowLogin={() => { setShowLogin(true); setMenuOpen(false); }}
          onShowWeather={() => { setShowWeather(true); setMenuOpen(false); }}
          onShowDiabetes={() => { setShowDiabetes(true); setMenuOpen(false); }}
          onShowHealthDataManager={() => { setShowHealthDataManager(true); setMenuOpen(false); }}
          onShowFoodIntake={() => { setShowFoodIntake(true); setMenuOpen(false); }}
          onShowFoodTemplates={() => { setShowFoodTemplates(true); setMenuOpen(false); }}
          onShowMacroCalc={() => { setShowMacroCalc(true); setMenuOpen(false); }}
          onShowGrafana={() => { setShowGrafana(true); setMenuOpen(false); }}
          onShowGestas={() => { setShowGestas(true); setMenuOpen(false); }}
          onShowAngelicare={() => { setShowAngelicare(true); setMenuOpen(false); }}
          onShowMakro={() => { setDisplayImage({ src: '/makro.jpg', title: 'makro' }); setMenuOpen(false); }}
          onShowSelgros={() => { setDisplayImage({ src: '/selgros.jpg', title: 'selgros' }); setMenuOpen(false); }}
          onShowNoteLists={() => { setShowNoteLists(true); setMenuOpen(false); }}
          onShowTaskLists={() => { setShowTaskLists(true); setMenuOpen(false); }}
          onShowEventLists={() => { setShowEventLists(true); setMenuOpen(false); }}
          onShowCyclicTasks={() => { setShowCyclicTasks(true); setMenuOpen(false); }}
          onShowMonthlyTasks={() => { setShowMonthlyTasks(true); setMenuOpen(false); }}
          onShowMonthlyTaskAdder={() => { setShowMonthlyTaskAdder(true); setMenuOpen(false); }}
          onShowCC={() => { setShowCC(true); setMenuOpen(false); }}
          onShowBalanceAccounts={() => { setShowBalanceAccounts(true); setMenuOpen(false); }}
          onShowCashflowExpenses={() => { setShowCashflowExpenses(true); setMenuOpen(false); }}
          onShowCashflowTracker={() => { setShowCashflowTracker(true); setMenuOpen(false); }}
          onShowBybit={() => { setShowBybit(true); setMenuOpen(false); }}
          onShowDriveInfo={() => { setShowDriveInfo(true); setMenuOpen(false); }}
          loggedIn={loggedIn}
          setLoggedIn={setLoggedIn}
        />

        {/* Default view */}
        {loggedIn && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
            }}
          >
            <div style={{ pointerEvents: 'auto' }}>
              <ShortcutsPanel
                onOpenSugarAdd={() => setShowSugarAdd(true)}
                onOpenInsulinAdd={() => setShowInsulinAdd(true)}
                onOpenFoodIntake={() => setShowFoodIntake(true)}
                onOpenTaskList={() => setShowTaskLists(true)}
                onOpenBaseAdd={() => setShowBaseAdd(true)}
                onOpenDailyEventsAdd={() => setShowDailyEventsAdd(true)}
              />
            </div> 
          </div>
        )}
        {displayImage && (
          <ImageDisplayPanel
            src={displayImage.src}
            title={displayImage.title}
            onClose={() => setDisplayImage(null)}
          />
        )}
        {showEventLists && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <EventListPanel onClose={() => setShowEventLists(false)} />
          </div>
        )}
        {showTaskLists && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <TaskListPanel onClose={() => setShowTaskLists(false)} />
          </div>
        )}

        {showFoodIntake && (
          <ModalShell onClose={() => setShowFoodIntake(false)} height={650}>
            <FoodIntakePanel onClose={() => setShowFoodIntake(false)} />
          </ModalShell>
        )}

        {showFoodTemplates && (
          <ModalShell onClose={() => setShowFoodTemplates(false)} height={650} width={620}>
            <FoodIntakeTemplateListPanel />
          </ModalShell>
        )}

        {showMacroCalc && (
          <ModalShell onClose={() => setShowMacroCalc(false)}>
            <MacroCalcPanel onClose={() => setShowMacroCalc(false)} />
          </ModalShell>
        )}

        {showSugarAdd && (
          <ModalShell onClose={() => setShowSugarAdd(false)}>
            <SugarAddPanel onClose={() => setShowSugarAdd(false)} />
          </ModalShell>
        )}

        {showInsulinAdd && (
          <ModalShell onClose={() => setShowInsulinAdd(false)}>
            <InsulinAddPanel onClose={() => setShowInsulinAdd(false)} />
          </ModalShell>
        )}

        {showBaseAdd && (
          <ModalShell onClose={() => setShowBaseAdd(false)}>
            <BaseAddPanel onClose={() => setShowBaseAdd(false)} />
          </ModalShell>
        )}

        {showDailyEventsAdd && (
          <ModalShell onClose={() => setShowDailyEventsAdd(false)}>
            <DailyEventsAddPanel onClose={() => setShowDailyEventsAdd(false)} />
          </ModalShell>
        )}

        {showMonthlyTaskAdder && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <MonthlyTaskAdderPanel
              onClose={() => setShowMonthlyTaskAdder(false)}
              onCancel={() => setShowMonthlyTaskAdder(false)}
              onAdd={() => setShowMonthlyTaskAdder(false)}
            />
          </div>
        )}
        {showNoteLists && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <NoteListsPanel onClose={() => setShowNoteLists(false)} />
          </div>
        )}

        {showCashflowExpenses && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <CashflowExpensePanel onClose={() => setShowCashflowExpenses(false)} />
          </div>
        )}

        {showCashflowTracker && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <CashflowTrackerPanel onClose={() => setShowCashflowTracker(false)} />
          </div>
        )}

        {showGestas && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <GestasPanel
              onClose={() => setShowGestas(false)}
            />
          </div>
        )}
        {showAngelicare && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <AngelicarePanel
              onClose={() => setShowAngelicare(false)}
            />
          </div>
        )}
        {showLogin && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div>
              <AuthTokenPanel
                onLogin={() => {
                  setLoggedIn(true);
                  setShowLogin(false);
                }}
                onClose={() => setShowLogin(false)}
              />
            </div>
          </div>
        )}
        {showWeather && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <WeatherPanel onClose={() => setShowWeather(false)} />
          </div>
        )}
        {showDiabetes && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <DiabetesPanel onClose={() => setShowDiabetes(false)} />
          </div>
        )}

        {showHealthDataManager && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <HealthDataManager onClose={() => setShowHealthDataManager(false)} />
          </div>
        )}

        {showGrafana && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <GrafanaPanel 
              onClose={() => setShowGrafana(false)} 
            />
          </div>
        )}
                {showCyclicTasks && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <CyclicTasksPanel onClose={() => setShowCyclicTasks(false)} />
          </div>
        )}
        {showMonthlyTasks && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <MonthlyTasksPanel onClose={() => setShowMonthlyTasks(false)} />
          </div>
        )}
        {showCC && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <CCPanel onClose={() => setShowCC(false)} />
          </div>
        )}
        {showBalanceAccounts && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <BalanceAccountPanel onClose={() => setShowBalanceAccounts(false)} />
          </div>
        )}
        {showBybit && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <BybitPanel onClose={() => setShowBybit(false)} />
          </div>
        )}
        {showDriveInfo && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <DriveInfoListPanel onClose={() => setShowDriveInfo(false)} />
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
